import { IrisBase } from './IrisBase';

export interface IIrisConfigContainerConstParam {    
    mod_settings:any
}

export class IrisConfigContainer<Tiris extends IrisBase> extends IrisBase  {
                
    public mod_settings:Tiris
    
    constructor({mod_settings }:IIrisConfigContainerConstParam) {        
        super()        
        this.mod_settings = mod_settings as Tiris
    }
}
